import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import ProtectedRoute from '@/components/ProtectedRoute';
import { CDXChatDocs } from '@/features/chat-docs/cdx-chat-docs';

const ChatDocs = () => {
  return (
    <ProtectedRoute>
      <>
        <Helmet>
          <title>Chat com Documentos - Justiçai</title>
          <meta name="description" content="Faça perguntas e obtenha respostas com base nos seus arquivos PDF, DOCX, TXT, MD e imagens." />
        </Helmet>
        <SidebarProvider>
          <div className="flex min-h-screen w-full">
            <AppSidebar />
            <main className="flex-1 w-full">
              <CDXChatDocs />
            </main>
          </div>
        </SidebarProvider>
      </>
    </ProtectedRoute>
  );
};

export default ChatDocs;
